import axios from "axios";

export const axiosInstance = axios.create({});

(window as any).sharedAxiosInstance = axiosInstance;
